import Gallery from './gallery';

const galleryConfig = {
  name: 'Gallery',
  class: Gallery,
  querySelector: {
    target: '.blocks-gallery-grid',
  },
  querySelectorAll: {
    images: '.blocks-gallery-item img',
  },
};

export default galleryConfig;
